import { render, staticRenderFns } from "./HochiScope.vue?vue&type=template&id=21dfb47a&scoped=true"
import script from "./HochiScope.vue?vue&type=script&lang=js"
export * from "./HochiScope.vue?vue&type=script&lang=js"
import style0 from "./HochiScope.vue?vue&type=style&index=0&id=21dfb47a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21dfb47a",
  null
  
)

export default component.exports